import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SurveyComponent } from './components/survey.component';


const routes: Routes = [
  { path: '', component: SurveyComponent },
];

export const routedComponents: any[] = [
  SurveyComponent,
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SurveyRoutingModule { }
